export default __webpack_public_path__ + "static/media/bio-estimulador.27465e7e.png";